// extracted by mini-css-extract-plugin
export default {"wrapper":"Option_wrapper__jCSHz"};